import React from "react";
import { useTranslation } from "react-i18next";

import { ProtectFlight } from "@airhelp/icons";
import { Box, Flex, Tag, VStack } from "@chakra-ui/react";

import { Journey } from "models/Journey";

import AirLuggageProtectBox from "./AirLuggageProtectBox";
import AirPayoutProtectBox from "./AirPayoutProtectBox";

interface IComponent {
  journey: Journey;
}

const ProtectBox: React.FC<IComponent> = ({ journey }) => {
  const { t } = useTranslation();

  const hasAirPayout = journey.hasAirPayout;

  return (
    <Box px={4} pt={6} pb={4} mb={4} background="greyscale.100" borderRadius="lg">
      <Flex alignItems="flex-start" justifyContent="space-between" flexWrap="nowrap" mb={5}>
        <Flex alignItems="center">
          <ProtectFlight color="primary.500" h={6} w="auto" mr={2} />
          <Box
            fontWeight="semibold"
            fontSize="lg"
            color="primary.900"
            lineHeight="shorter"
            data-testid="your-trip-protection"
          >
            {t("common.your_trip_protection")}
          </Box>
        </Flex>
        <Tag size="xs" backgroundColor="success.500" color="greyscale.100" display="inline-block" minW="unset">
          {t("common.new")}
        </Tag>
      </Flex>
      <VStack spacing={3}>
        {hasAirPayout && <AirPayoutProtectBox journey={journey} />}
        {journey.airLuggageJourneys.map((airLuggageJourney) => (
          <AirLuggageProtectBox airLuggageJourney={airLuggageJourney} key={airLuggageJourney.id} />
        ))}
      </VStack>
    </Box>
  );
};

export default ProtectBox;
